export const entityProviderDataKeysEnum = {
  general: '196b13d9-1f8a-4d60-9146-ca87a7ac136b',
  consultation: 'de6cf4d5-fe06-4da3-b057-5df4fd610191',
  labs: 'e09fc1c7-c3c6-442f-a2f1-84fe07a8129c',
  scans: '57161a64-d0ee-42e0-9ea8-c79eb641e496',
  clinic: '5cc48872-e4ea-4430-8efa-32abeb42e79a',
  surgical: '19700552-531d-4176-8e3c-a8c7d31f608c',
  emergency: '0cb9d3bc-502a-4511-80f9-3a30946bd68d',
  icu: '3f32e82b-f09b-4ba1-b066-cc2fbd7d6626',
};
